import { Action } from 'redux'
import { SearchActions } from '../../reducers/search/actionNames'

const loadSearch = (): Action => ({
  type: SearchActions.LoadSearch,
})

const searchIsReady = (): Action => ({
  type: SearchActions.SearchIsReady,
})

const searchLoadingFailed = (message: string): ISearchLoadingFailed => ({
  message,
  type: SearchActions.SearchLoadingFailed,
})

export { loadSearch, searchIsReady, searchLoadingFailed }

export interface ISearchLoadingFailed
  extends Action<SearchActions.SearchLoadingFailed> {
  message: string
}
